import { request } from '../network_new';

const userServices = {
  // 获取用户信息认证状态
  getCertificationData(data?: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 325308,
        headerType: 2,
        paramType: 0,
        apiName: 'getCertificationData',
      },
    });
  },
  // 查询用户密码是否为空
  reqHasPassword(data: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310160,
        headerType: 2,
        paramType: 0,
        apiName: 'reqHasPassword',
      },
    });
  },
};

export default userServices;
